import React from 'react';
import { motion } from 'framer-motion';
import { AiOutlineDownload } from 'react-icons/ai';
import { FiExternalLink, FiCalendar, FiBarChart2, FiUsers, FiShield } from 'react-icons/fi';

import '../assets/bootstrap/css/bootstrap.min.css';
import '../assets/bootstrap/css/bootstrap-grid.min.css';
import '../assets/bootstrap/css/bootstrap-reboot.min.css';
import '../assets/theme/css/style.css';
import '../assets/mobirise/css/mbr-additional.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import igualdade from '../assets/igualdade-salarial.pdf';
import fachada from './assets/images/6-768x1024.jpg';
import transmissao from './assets/images/3.jpg';

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0 },
};

const stagger = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const sectionReveal = {
  initial: 'hidden',
  whileInView: 'show',
  viewport: { once: true, amount: 0.18 },
  variants: fadeUp,
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

function SectionTag({ children, light = false }) {
  return (
    <span
      style={{
        display: 'inline-block',
        marginBottom: '14px',
        fontSize: '0.82rem',
        fontWeight: 700,
        letterSpacing: '1.4px',
        textTransform: 'uppercase',
        color: light ? '#d6a04a' : '#b7832f',
      }}
    >
      {children}
    </span>
  );
}

function SectionTitle({ children, center = false, light = false, maxWidth = '760px' }) {
  return (
    <h2
      style={{
        fontSize: 'clamp(2rem, 3vw, 3.2rem)',
        lineHeight: 1.12,
        fontWeight: 800,
        letterSpacing: '-0.8px',
        color: light ? '#ffffff' : '#0d2e63',
        marginBottom: '18px',
        maxWidth,
        marginLeft: center ? 'auto' : 0,
        marginRight: center ? 'auto' : 0,
      }}
    >
      {children}
    </h2>
  );
}

function SectionText({ children, center = false, light = false, maxWidth = '760px' }) {
  return (
    <p
      style={{
        fontSize: '1.04rem',
        lineHeight: 1.9,
        color: light ? 'rgba(255,255,255,0.78)' : '#5f7088',
        maxWidth,
        margin: center ? '0 auto' : 0,
      }}
    >
      {children}
    </p>
  );
}

export default function Transparencia() {
  const previewUrl = `${igualdade}#toolbar=1&navpanes=0&scrollbar=1&view=FitH`;

  const highlights = [
    {
      title: 'Compromisso com a transparência',
      text: 'Divulgação clara de informações relevantes, em conformidade com a legislação vigente e com as melhores práticas institucionais.',
      icon: <FiShield size={22} />,
    },
    {
      title: 'Critérios objetivos',
      text: 'Adoção de parâmetros consistentes para remuneração, reforçando responsabilidade, clareza e respeito nas relações de trabalho.',
      icon: <FiBarChart2 size={22} />,
    },
    {
      title: 'Diversidade e inclusão',
      text: 'Promoção de um ambiente mais justo, respeitoso e alinhado à valorização das pessoas.',
      icon: <FiUsers size={22} />,
    },
  ];

  return (
    <div
      style={{
        background: 'linear-gradient(180deg, #f3f6fb 0%, #ffffff 30%, #f7f9fc 100%)',
        color: '#11233e',
        fontFamily: 'Arial, sans-serif',
        overflow: 'hidden',
      }}
    >
      <Navbar />

      <section
        style={{
          position: 'relative',
          minHeight: '72vh',
          display: 'flex',
          alignItems: 'center',
          backgroundImage: `linear-gradient(95deg, rgba(8,20,41,0.95) 0%, rgba(10,33,70,0.9) 42%, rgba(13,52,110,0.68) 100%), url(${fachada})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(circle at 15% 20%, rgba(255,255,255,0.08), transparent 22%), radial-gradient(circle at 85% 12%, rgba(214,160,74,0.18), transparent 16%)',
          }}
        />

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row align-items-center g-5">
            <div className="col-lg-7">
              <motion.div {...sectionReveal} style={{ maxWidth: '760px', padding: '50px 0' }}>
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 16px',
                    borderRadius: '999px',
                    background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    color: 'rgba(255,255,255,0.84)',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    marginBottom: '24px',
                  }}
                >
                  Transparência institucional
                </div>

                <h1
                  style={{
                    fontSize: 'clamp(2.5rem, 5vw, 4.7rem)',
                    lineHeight: 1.03,
                    fontWeight: 800,
                    letterSpacing: '-1.2px',
                    color: '#ffffff',
                    marginBottom: '22px',
                  }}
                >
                  Transparência, responsabilidade e compromisso com a valorização das pessoas.
                </h1>

                <p
                  style={{
                    fontSize: '1.08rem',
                    lineHeight: 1.9,
                    color: 'rgba(255,255,255,0.82)',
                    maxWidth: '650px',
                  }}
                >
                  A RealEnergy disponibiliza informações institucionais relevantes de forma clara e acessível,
                  reforçando seu compromisso com conformidade, igualdade salarial, diversidade e práticas responsáveis
                  de gestão.
                </p>
              </motion.div>
            </div>

            <div className="col-lg-5">
              <motion.div
                initial={{ opacity: 0, y: 34 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.08 }}
                style={{ position: 'relative', maxWidth: '500px', marginLeft: 'auto' }}
              >
                <motion.div
                  animate={{ y: [0, -8, 0] }}
                  transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
                  style={{
                    position: 'relative',
                    background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: '30px',
                    padding: '18px',
                    backdropFilter: 'blur(16px)',
                    boxShadow: '0 30px 80px rgba(0,0,0,0.24)',
                  }}
                >
                  <img
                    src={transmissao}
                    alt="Transparência institucional"
                    style={{
                      width: '100%',
                      height: '420px',
                      objectFit: 'cover',
                      borderRadius: '24px',
                      display: 'block',
                    }}
                  />

                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.25 }}
                    whileHover={{ y: -4 }}
                    style={{
                      position: 'absolute',
                      left: '-20px',
                      bottom: '34px',
                      width: '250px',
                      background: 'rgba(255,255,255,0.97)',
                      borderRadius: '22px',
                      padding: '18px',
                      boxShadow: '0 20px 55px rgba(15, 23, 42, 0.18)',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '0.78rem',
                        color: '#b7832f',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        marginBottom: '8px',
                        fontWeight: 700,
                      }}
                    >
                      Publicação oficial
                    </div>
                    <div
                      style={{
                        fontWeight: 800,
                        fontSize: '1.12rem',
                        marginBottom: '6px',
                        color: '#0d2e63',
                        lineHeight: 1.3,
                      }}
                    >
                      Informações acessíveis com leitura mais organizada.
                    </div>
                    <div style={{ color: '#607089', fontSize: '0.95rem', lineHeight: 1.6 }}>
                      Um ambiente digital mais claro para consulta de documentos e relatórios institucionais.
                    </div>
                  </motion.div>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ marginTop: '-48px', position: 'relative', zIndex: 3 }}>
        <div className="container">
          <motion.div
            {...sectionReveal}
            style={{
              background: 'rgba(255,255,255,0.95)',
              borderRadius: '28px',
              boxShadow: '0 24px 70px rgba(15, 23, 42, 0.08)',
              border: '1px solid rgba(15, 23, 42, 0.05)',
              padding: '30px',
            }}
          >
            <motion.div
              className="row g-4"
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.15 }}
            >
              {highlights.map((item, index) => (
                <div className="col-lg-4" key={index}>
                  <motion.div
                    variants={fadeUp}
                    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    whileHover={{ y: -8, boxShadow: '0 24px 48px rgba(13, 46, 99, 0.08)' }}
                    style={{
                      background: '#ffffff',
                      borderRadius: '22px',
                      padding: '28px 24px',
                      height: '100%',
                      border: '1px solid rgba(13, 46, 99, 0.06)',
                    }}
                  >
                    <div
                      style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '16px',
                        background: 'linear-gradient(135deg, #edf3ff, #f7efe1)',
                        marginBottom: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#0d2e63',
                      }}
                    >
                      {item.icon}
                    </div>

                    <h3
                      style={{
                        fontSize: '1.22rem',
                        fontWeight: 800,
                        marginBottom: '12px',
                        color: '#0d2e63',
                      }}
                    >
                      {item.title}
                    </h3>

                    <p style={{ color: '#607089', lineHeight: 1.8, marginBottom: 0 }}>{item.text}</p>
                  </motion.div>
                </div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section>

      <section style={{ padding: '110px 0 60px' }}>
        <div className="container">
          <motion.div {...sectionReveal} className="text-center" style={{ maxWidth: '920px', margin: '0 auto 50px' }}>
            <SectionTag>Relatório oficial</SectionTag>
            <SectionTitle center maxWidth="920px">
              Relatório de Transparência e Igualdade Salarial de Mulheres e Homens – 2º semestre de 2025.
            </SectionTitle>
            <SectionText center maxWidth="860px">
              Em cumprimento à legislação vigente, a RealEnergy disponibiliza este relatório como parte do seu compromisso
              com a transparência institucional, a valorização das pessoas e a adoção de critérios objetivos de remuneração.
            </SectionText>
          </motion.div>

          <div className="row g-4 align-items-stretch">
            <div className="col-xl-4">
              <motion.div
                {...sectionReveal}
                style={{
                  background: '#ffffff',
                  borderRadius: '28px',
                  padding: '24px',
                  border: '1px solid rgba(13, 46, 99, 0.06)',
                  boxShadow: '0 20px 50px rgba(15, 23, 42, 0.07)',
                  height: '100%',
                }}
              >
                <SectionTag>Sobre o documento</SectionTag>
                <SectionTitle maxWidth="100%">Informações para consulta</SectionTitle>

                <div style={{ display: 'grid', gap: '16px', marginTop: '20px' }}>
                  <div
                    style={{
                      background: '#f8fbff',
                      borderRadius: '18px',
                      padding: '18px',
                      border: '1px solid rgba(13, 79, 179, 0.08)',
                    }}
                  >
                    <div style={{ fontWeight: 800, color: '#0d2e63', marginBottom: '8px' }}>
                      Conteúdo
                    </div>
                    <div style={{ color: '#607089', lineHeight: 1.7 }}>
                      Relatório de Transparência e Igualdade Salarial de Mulheres e Homens.
                    </div>
                  </div>

                  <div
                    style={{
                      background: '#ffffff',
                      borderRadius: '18px',
                      padding: '18px',
                      border: '1px solid rgba(13, 46, 99, 0.06)',
                    }}
                  >
                    <div style={{ fontWeight: 800, color: '#0d2e63', marginBottom: '8px' }}>
                      Finalidade
                    </div>
                    <div style={{ color: '#607089', lineHeight: 1.7 }}>
                      Reforçar o compromisso institucional com transparência, diversidade, inclusão e práticas responsáveis de gestão.
                    </div>
                  </div>

                  <div
                    style={{
                      background: '#ffffff',
                      borderRadius: '18px',
                      padding: '18px',
                      border: '1px solid rgba(13, 46, 99, 0.06)',
                    }}
                  >
                    <div style={{ fontWeight: 800, color: '#0d2e63', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <FiCalendar size={16} />
                      Publicação
                    </div>
                    <div style={{ color: '#607089', lineHeight: 1.7 }}>
                      <time dateTime="2025-09-29">29/09/2025</time>
                    </div>
                  </div>
                </div>

                <div style={{ display: 'grid', gap: '12px', marginTop: '22px' }}>
                  <motion.a
                    whileHover={{ y: -2, scale: 1.01 }}
                    whileTap={{ scale: 0.98 }}
                    href={igualdade}
                    download
                    style={{
                      textDecoration: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px',
                      padding: '15px 18px',
                      borderRadius: '14px',
                      background: 'linear-gradient(135deg, #0d4fb3, #0a3d91)',
                      color: '#ffffff',
                      fontWeight: 700,
                      boxShadow: '0 18px 36px rgba(13, 79, 179, 0.2)',
                    }}
                  >
                    <AiOutlineDownload size={18} />
                    Baixar relatório
                  </motion.a>

                  <motion.a
                    whileHover={{ y: -2, scale: 1.01 }}
                    whileTap={{ scale: 0.98 }}
                    href={igualdade}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      textDecoration: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px',
                      padding: '15px 18px',
                      borderRadius: '14px',
                      background: '#f4f8ff',
                      color: '#0d4fb3',
                      fontWeight: 700,
                      border: '1px solid rgba(13, 79, 179, 0.12)',
                    }}
                  >
                    <FiExternalLink size={17} />
                    Abrir em nova guia
                  </motion.a>
                </div>
              </motion.div>
            </div>

            <div className="col-xl-8">
              <motion.div
                {...sectionReveal}
                style={{
                  background: '#ffffff',
                  borderRadius: '28px',
                  padding: '24px',
                  border: '1px solid rgba(13, 46, 99, 0.06)',
                  boxShadow: '0 20px 50px rgba(15, 23, 42, 0.07)',
                  height: '100%',
                }}
              >
                <div style={{ marginBottom: '20px' }}>
                  <div
                    style={{
                      fontSize: '0.76rem',
                      fontWeight: 700,
                      letterSpacing: '1.2px',
                      textTransform: 'uppercase',
                      color: '#b7832f',
                      marginBottom: '8px',
                    }}
                  >
                    Visualização do documento
                  </div>

                  <h3
                    style={{
                      fontSize: '1.5rem',
                      fontWeight: 800,
                      color: '#0d2e63',
                      marginBottom: '10px',
                    }}
                  >
                    Relatório de Transparência e Igualdade Salarial
                  </h3>

                  <p
                    style={{
                      color: '#607089',
                      lineHeight: 1.8,
                      marginBottom: 0,
                    }}
                  >
                    A visualização abaixo foi organizada para facilitar a consulta. Caso o navegador ou dispositivo não suporte o preview, utilize as opções de download ou abertura em nova guia.
                  </p>
                </div>

                <div
                  style={{
                    borderRadius: '24px',
                    overflow: 'hidden',
                    border: '1px solid rgba(13, 46, 99, 0.08)',
                    background: '#f7f9fc',
                    minHeight: '780px',
                  }}
                >
                  <iframe
                    title="Relatório de Transparência e Igualdade Salarial"
                    src={previewUrl}
                    style={{
                      width: '100%',
                      height: '780px',
                      border: 'none',
                      display: 'block',
                      background: '#ffffff',
                    }}
                  />
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '0 0 110px' }}>
        <div className="container">
          <motion.div
            {...sectionReveal}
            style={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '34px',
              padding: '64px 30px',
              backgroundImage: `linear-gradient(135deg, rgba(9,28,59,0.94), rgba(14,63,148,0.9)), url(${transmissao})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              textAlign: 'center',
              boxShadow: '0 28px 72px rgba(15, 23, 42, 0.16)',
            }}
          >
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'radial-gradient(circle at top center, rgba(255,255,255,0.1), transparent 28%)',
              }}
            />

            <div style={{ maxWidth: '820px', margin: '0 auto', position: 'relative', zIndex: 2 }}>
              <SectionTag light>Compromisso contínuo</SectionTag>
              <SectionTitle light center maxWidth="820px">
                Transparência como parte da relação de confiança entre empresa, pessoas e sociedade.
              </SectionTitle>
              <SectionText light center maxWidth="760px">
                A divulgação deste relatório reforça a postura institucional da RealEnergy na construção de relações mais claras,
                responsáveis e alinhadas às exigências legais e aos valores que orientam sua atuação.
              </SectionText>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}